import React from "react";
import "./Subtotal.css";
import { connect } from "react-redux";
import {
  getTotalPriceSelector,
  itemsInCartSelector,
} from "../../Reducers/AddToCartReducer";
import { useHistory } from "react-router-dom";
import CurrencyFormat from "react-currency-format";

function Subtotal({ totalPrice, itemsInCart }) {
  const history = useHistory();
  const navigateToPayment = (e) => {
    if (totalPrice === 0) return alert("Please select some products");
    history.push("/payment");
  };
  return (
    <div className="subtotal">
      <CurrencyFormat
        renderText={(value) => (
          <>
            <p>
              Subtotal ({itemsInCart} items): <strong>{value}</strong>
            </p>
            <small className="subtotal__gift">
              <input type="checkbox" /> This order contains a gift
            </small>
          </>
        )}
        decimalScale={2}
        value={totalPrice}
        displayType={"text"}
        thousandSeparator={true}
        prefix={"$"}
      />

      <button onClick={navigateToPayment}>Proceed to checkout</button>
    </div>
  );
}

export default connect(
  (state) => ({
    itemsInCart: itemsInCartSelector(state),
    totalPrice: getTotalPriceSelector(state),
  }),
  null
)(Subtotal);
